import StoreAuth from 'GlobalStores/User/StoreAuth'
import { makeAutoObservable, runInAction } from 'mobx'

import feelGreateAPI from './APIs'
import { get } from 'lodash'
import { ObjectHelpers } from 'Helpers/ObjectHelpers'

class StoreFeelGreat {
    referral = {
        id: '',
        humanName: {},
        shortStatus: ''
    }

    // ตัวเก่า
    // useReferral = false
    // checkReferralId = null
    // referralId = ''
    // referralName = ''
    // stateReferrenceId = null

    forms = {
        createYourAccount: null,
        shippingAddress: null
    }

    defaultValues = {
        flavor: 'flavor_0',
        purchaseOption: 'subscribe'
    }

    orderSummary = {
        isShowReferredBy: {
            onetime: false,
            subscription: false
        },
        isShowSubscriptionMessage: {
            onetime: false,
            subscription: false
        },
        isShowMemberDiscount: {
            onetime: false,
            subscription: false
        },
        isShowSubscriptionDiscount: {
            onetime: false,
            subscription: false
        },
        referredBy: {
            native: '',
            english: ''
        },
        subscriptionMessage: {
            native: '',
            english: ''
        }
    }

    contents = {
        description: null,
        expertsSay: null,
        mainBanner: null,
        howItWorks: null,
        ourApproach: null,
        questions: null,
        realResults: null,
        secondBanner: null,
        thePractice: null,
        theProducts: null,
        quickLinks: null,
        disclaimer: null,
        privacyPolicy: null,
        privacyPolicyLink: null,
        termOfUse: null,
        social: null,
        memberPriceUnlockReadMore: null,
        moneyBackGuarantee: null,
        moneyBack: null,
        contact: null,
        guide: null,
        guideButton: null,
        socialStoriesGuidelines: null,
        freeItems: null,
        referralLinks: null,
        referralLinksSorted: []
    }

    imagesSlider = []
    image = ''

    purchaseOptions = []

    isInit = false

    referralCode = ''

    loadingReferCode = false

    productCredit = null

    Init(data) {
        Object.keys(data).map(key => {
            runInAction(() => {
                if (this.forms[key] !== undefined) {
                    this.forms[key] = data[key]
                } else if (this.contents[key] !== undefined) {
                    this.contents[key] = data[key]
                } else if (key === 'images') {
                    this.imagesSlider = data[key]
                } else if (this[key] !== undefined) {
                    this[key] = data[key]
                }
            })

            return true
        })

        runInAction(() => {
            this.isInit = true
        })
    }

    GetCheckoutForms() {
        return this.forms
    }

    GetOrderSummaryConditions() {
        return this.orderSummary
    }

    GetImagesSlider() {
        return this.imagesSlider
    }

    GetIsInit() {
        return this.isInit
    }

    GetContent(section) {
        return this.contents[section]
    }

    GetPurchaseOptions() {
        return this.purchaseOptions
    }

    GetImage() {
        return this.image
    }

    AddOnceItemToImage(img) {
        runInAction(() => {
            this.image = img
        })
    }

    UsePrice() {
        if (StoreAuth.GetId()) {
            return 'after'
        } else if (this.referral.id.length > 0) {
            return 'after'
        } else {
            return 'retail'
        }
    }

    SetReferralData(userRef, status) {
        this.referral.id = userRef.unicity
        this.referral.humanName = userRef.humanName
        this.referral.shortStatus = status
    }

    GetReferal() {
        return this.referral
    }

    HasReferral() {
        return this.referral.id && !ObjectHelpers.isEmpty(this.referral.humanName) ? this.referral.id : false
    }

    IsAllowProductCredit() {
        return get(this.productCredit, 'isEnable')
    }

    constructor() {
        makeAutoObservable(this)
    }

    async GetReferralCode(token) {
        try {
            this.loadingReferCode = true
            let response = await feelGreateAPI.getReferralCodes(token)
            this.referralCode = get(response, 'data.items[0].referralCode', '')
            this.loadingReferCode = false
        } catch (error) {
            console.log('getReferralCode error => ', error)
            this.loadingReferCode = false
        }
    }
}

const storeFeelGreat = new StoreFeelGreat()
export default storeFeelGreat
